// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WifiIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M11.9 5.2c3.07 0 6.06 1.07 8.43 3.04.73.59.87 1.25.4 1.8-.46.57-1.08.53-1.8-.03-4.35-3.49-9.51-3.48-13.88.02-.67.54-1.35.54-1.78-.02q-.66-.84.35-1.69a13.2 13.2 0 0 1 8.27-3.12"
    />
    <path
      fill="currentColor"
      d="M12.25 8.86a9 9 0 0 1 5.68 2.24c.67.59.77 1.25.3 1.78-.44.5-1.1.47-1.73-.05-2.83-2.36-6.05-2.36-8.93 0-.69.55-1.34.55-1.8 0-.42-.53-.3-1.13.32-1.71a9.2 9.2 0 0 1 6.16-2.26"
    />
    <path
      fill="currentColor"
      d="M12.02 12.49c1.32.04 2.59.54 3.58 1.41.57.5.64 1.17.21 1.66-.4.46-1.05.5-1.62.09-1.7-1.22-2.62-1.22-4.33-.01-.6.42-1.22.38-1.62-.08-.44-.5-.35-1.17.2-1.67a6 6 0 0 1 3.58-1.4M12 16.38a1.36 1.36 0 0 1 1.36 1.34 1.4 1.4 0 0 1-1.3 1.32 1.33 1.33 0 0 1-1.34-1.34A1.3 1.3 0 0 1 12 16.38"
    />
  </svg>,
  "Wifi",
);
export default WifiIcon;
